module.exports = __webpack_public_path__ + "static/img/17.73d6fd2.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/aboutUs/companys/17.png
// module id = DkYn
// module chunks = 1